/* eslint-disable import/prefer-default-export */
// equivalent clearcut area module map styles
export const EQUIVALENT_CLEARCUT_AREA = {
    BASE: {
        URL: 'mapbox://styles/foundryspatial/ckyf16xjv1q5t14p6xyaifce3',
    },
    SATELLITE: {
        URL: 'mapbox://styles/foundryspatial/ckxb2dqbc0u5s17pegf8uqfgf',
    },
};
